import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import PaymentResultShell from './PaymentResultShell';

const Pending = () => {
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get('payment_id');
  const externalReference = searchParams.get('external_reference');

  useEffect(() => {
    document.title = 'Pago pendiente · Privistore';
    return () => {
      document.title = 'Privistore';
    };
  }, []);

  return (
    <PaymentResultShell
      variant="pending"
      title="Pago en proceso"
      subtitle="Tu pago está siendo revisado por el medio de pago. Puede tardar unos minutos. Te avisamos por correo cuando esté acreditado; no cierres si tu banco te pide confirmar."
      primaryLabel="Ir al inicio"
      primaryTo="/"
      secondaryLabel="Ver productos"
      secondaryTo="/productos"
    >
      {(paymentId || externalReference) && (
        <dl className="mp-result__meta">
          {externalReference && (
            <>
              <dt>Referencia</dt>
              <dd>{externalReference}</dd>
            </>
          )}
          {paymentId && (
            <>
              <dt>ID de pago</dt>
              <dd>{paymentId}</dd>
            </>
          )}
        </dl>
      )}
    </PaymentResultShell>
  );
};

export default Pending;
